/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class TimeFrame {
  /**
  * Start time for the cost data query in ISO 8601 format. Must be at least 24 hours before end time. 
  */
  'startTime': Date;
  /**
  * End time for the cost data query in ISO 8601 format. 
  */
  'endTime': Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "startTime",
      "baseName": "startTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "endTime",
      "baseName": "endTime",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return TimeFrame.attributeTypeMap;
  }

  public constructor() {
  }
}

